import Layout from "@/project/propertyPortal/components/Layout";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/project/propertyPortal/components/ui/card";
import { ExternalLink, Receipt, ScrollText, Shield } from "lucide-react";

/** LawDepot — business contracts (external redirect). */
const LAWDEPOT_BUSINESS_CONTRACTS_URL =
  "https://www.lawdepot.com/contracts/groups/business/?loc=US&pid=googleppc-gbus_us-contractsT1_a1-ggkey_free%20business%20contracts&gclid=Cj0KEQiAl5u2BRC6yszC1_75v5wBEiQAD-hdz4e9ve2dTeu1R_ClIcXCCYlwrbzFW3GJOxx66agly6UaAow88P8HAQ#.Ywt_OezMKCR";

const REINSUREPRO_URL = "https://reinsurepro.com/";

const TAX_TITLE_SERVICES_ORDER_URL =
  "https://www.taxtitleservices.com/order-now/";

const PP_ImportantWebsite = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">
            Important Websites
          </h1>
          <p className="text-muted-foreground">
            External resources and portals related to Property Investment.
          </p>
        </div>

        <div className="flex max-w-xl flex-col gap-6">
          <a
            href={LAWDEPOT_BUSINESS_CONTRACTS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-xl no-underline outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <Card className="border-border shadow-sm transition-colors group-hover:border-primary/40 group-hover:shadow-md">
              <CardHeader>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <ScrollText
                      className="h-5 w-5 shrink-0 text-primary"
                      aria-hidden
                    />
                    <CardTitle className="text-foreground">
                      LawDepot — Business contracts
                    </CardTitle>
                  </div>
                  <ExternalLink
                    className="h-5 w-5 shrink-0 text-muted-foreground transition-colors group-hover:text-primary"
                    aria-hidden
                  />
                </div>
                <CardDescription>
                  Opens LawDepot’s business contracts page in a new tab.
                </CardDescription>
              </CardHeader>
            </Card>
          </a>

          <a
            href={REINSUREPRO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-xl no-underline outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <Card className="border-border shadow-sm transition-colors group-hover:border-primary/40 group-hover:shadow-md">
              <CardHeader>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <Shield
                      className="h-5 w-5 shrink-0 text-primary"
                      aria-hidden
                    />
                    <CardTitle className="text-foreground">
                      REInsurePro
                    </CardTitle>
                  </div>
                  <ExternalLink
                    className="h-5 w-5 shrink-0 text-muted-foreground transition-colors group-hover:text-primary"
                    aria-hidden
                  />
                </div>
                <CardDescription>
                  Insurance programs for residential real estate investment
                  properties. Opens reinsurepro.com in a new tab.
                </CardDescription>
              </CardHeader>
            </Card>
          </a>

          <a
            href={TAX_TITLE_SERVICES_ORDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-xl no-underline outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <Card className="border-border shadow-sm transition-colors group-hover:border-primary/40 group-hover:shadow-md">
              <CardHeader>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <Receipt
                      className="h-5 w-5 shrink-0 text-primary"
                      aria-hidden
                    />
                    <CardTitle className="text-foreground">
                      Tax Title Services — Order now
                    </CardTitle>
                  </div>
                  <ExternalLink
                    className="h-5 w-5 shrink-0 text-muted-foreground transition-colors group-hover:text-primary"
                    aria-hidden
                  />
                </div>
                <CardDescription>
                  Tax and title services ordering. Opens taxtitleservices.com in
                  a new tab.
                </CardDescription>
              </CardHeader>
            </Card>
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default PP_ImportantWebsite;
